export const collectionUrl = (id) => `/collections/${id}`;
export const collectionItemCount = (count) =>
  `${count} ${count === 1 ? "Item" : "Items"}`;
export const collectionVisibility = (bool) =>
  bool ? "Public Collection" : "Private Collection";
